import * as React from "react";
const SvgDashboard24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v9h9V0H1Zm1 7V2h5v5H2Zm-1 4H0v9h9v-9H1Zm1 7v-5h5v5H2Zm9-18h9v9h-9V0Zm2 2v5h5V2h-5Zm-1 9h-1v9h9v-9h-8Zm1 7v-5h5v5h-5Z",
      clipRule: "evenodd"
    })
  );
export default SvgDashboard24Px;
